var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCandyCanes = function SvgCandyCanes(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_7KkuMB",
    "data-name": "7KkuMB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.52,285.9,102,282.58c14.83-20.22,45.31-27.21,70.25-.24a5.41,5.41,0,0,1,4.6-2.78c16-.22,32-2.4,48-1.05,9.64-21,6.64-34-11.41-49.68-52.91,4-106.28,6.78-159.34,6.44C49.72,240,31,280.49,32.52,285.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.05,235.27c53.06.34,106.43-2.48,159.34-6.44C165.65,184.39,97.66,183.51,54.05,235.27Z",
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.24,565.72c13.61,13.35,31.24,27.94,51.68,21.4,9-2.89,19.58-14.78,19.45-24.34C304.92,564.07,288.64,564.33,260.24,565.72Z",
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,567.15c8.13-3.35,53.54-2.07,69.58-4.37,9.11-23.56-17.69-36.87-30.9-51.71-2.34,3.26-5.85,1.75-8.78,1.9-27.92,1.36-55.85,2.52-83.77,3.75C225,534.5,243.77,550.4,261.79,567.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,425.19l50.9,47.13c29.61-5.25,61.61-3,92.05-5.66l-49.12-45.89C170.71,423.68,139.26,423.47,108,425.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,425.19c31.25-1.72,62.7-1.51,93.83-4.42l-49.69-45.62L60.7,379.61C67.27,387.45,97.09,415.14,108,425.19Z",
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,466.66c-30.43,2.68-62.44.41-92.05,5.66l49,44.4c27.92-1.23,55.85-2.39,83.77-3.75,2.93-.15,6.44,1.36,8.78-1.9Z",
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,379.61l91.45-4.46c-15.57-15.5-33.41-28.65-47.45-45.74C81.18,331.55,57.53,332,34,333.36,37.53,351.87,46.71,367.13,60.7,379.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,333.36c23.57-1.39,47.22-1.81,70.74-3.95-11.16-15-10.07-30.74-2.74-46.83L32.52,285.9C27.25,303.63,28.91,317.25,34,333.36Z",
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.8,278.51c-16-1.35-32,.83-48,1.05-2.12,0-10.05-1.38-4.6,2.78C190.51,298.1,209.57,296.71,224.8,278.51Z",
    fill: "#f0592b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7KkuMB-2",
    "data-name": "7KkuMB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.48,73.85,482.73,89.46C463,74,431.75,75.52,415,108.24a5.4,5.4,0,0,0-5.18-1.43c-15.46,4.12-31.41,6.34-46.48,12-15-17.59-15.61-30.95-2.47-50.91,52-10.52,104.15-22.25,155.14-36.94C521.49,34.29,550.5,68.23,550.48,73.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.05,30.94c-51,14.69-103.13,26.42-155.14,36.94C394.84,12.17,460.05-7.08,516.05,30.94Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,404.86c-9.49,16.54-22.52,35.36-44,34.61-9.46-.35-22.85-8.94-25.31-18.17C363.55,415.37,379.3,411.21,407,404.86Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.91,406.66c-8.74-1-52.1,12.5-68.17,14.64-15.14-20.22,7.05-40.28,15.75-58.14,3.13,2.5,6.11.09,9-.56,27.24-6.25,54.44-12.69,81.66-19.07C432.52,365.26,418.72,385.67,405.91,406.66Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.52,228.38l-36.25,59.15c-29.92,3-60.11,13.8-90.14,19.46L424,249.53C454.75,243.9,485,235.18,515.52,228.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.52,228.38C485,235.18,454.75,243.9,424,249.53l35.49-57.38,89.24-20.46C544.52,181,523.31,215.75,515.52,228.38Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.13,307c30-5.65,60.22-16.5,90.14-19.46l-35.15,56c-27.22,6.38-54.42,12.82-81.66,19.07-2.86.65-5.84,3.06-9,.56Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.72,171.69l-89.24,20.46c10.79-19.13,24.41-36.62,33.29-56.88,23.22-4.3,46.1-10.3,69.17-15.34C563.51,138.71,558.81,155.89,548.72,171.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.94,119.93c-23.07,5-46,11-69.17,15.34,6.68-17.47,1.38-32.31-10-45.82l67.75-15.6C560.36,89.49,562.44,103.05,561.94,119.93Z",
    fill: "#93b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.38,118.79c15.07-5.64,31-7.86,46.48-12,2.05-.55,9.3-4,5.18,1.43C401.69,128.36,383,132.19,363.38,118.79Z",
    fill: "#93b847"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.23,113.8c3.62,0,33.38,1.12,33.38,36.16a3.67,3.67,0,0,0,3.61,3.61c1.67.28,3.34-1.38,3.34-3.33,0-35.05,30-36.16,33.37-36.16h.28a3.75,3.75,0,0,0,3.62-3.89,3.69,3.69,0,0,0-3.62-3.62c-3.33,0-33.37-1.11-33.37-36.15a3.62,3.62,0,1,0-7.23,0c0,35-30,36.15-33.38,36.15H208a3.63,3.63,0,0,0-3.33,3.62A3.68,3.68,0,0,0,208.23,113.8Z",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCandyCanes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/candy_canes.8d32c853.svg";
export { ForwardRef as ReactComponent };